export const generativeAiAgentIdVersions = "/generative_ai/agent/:id/versions";
